import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"

const LoggedHinSigning = () => {
  const { t } = useTranslation()

  useEffect(() => {
    const sendMessage = () => {
      if (window.opener) {
        window.opener.postMessage({ action: "hin-logged" }, `${window.location.origin}/patients`)
      }
      window.close()
    }

    sendMessage()
  }, [])

  const handleCloseButtonClick = () => {
    window.close()
  }

  return (
    <div className="flex h-screen flex-col items-center justify-center">
      <p className="text-success mb-4 text-2xl font-bold">{t("hin.loginHinSuccessfully")}</p>
      <Button variant="secondary" onClick={handleCloseButtonClick}>
        {t("common.button.close")}
      </Button>
    </div>
  )
}

export { LoggedHinSigning }
